export default defineNuxtPlugin((nuxtApp) => {
  // Global Event Bus & Toast Shim
  // In Nuxt 4 we use nuxtApp.$bus (provided by event-bus.client.js)

  nuxtApp.provide('toast', (options) => {
    nuxtApp.$bus.emit('add-toast', {
      message: options.message,
      duration: options.duration || 3500,
      type: options.type,
      title: options.title,
    });
  });

  // Shim for $confirmationModal
  nuxtApp.provide('confirmationModal', (options) => {
    nuxtApp.$bus.emit('show-confirmation-modal', options);
  });

  // Shim for $universalModal
  nuxtApp.provide('universalModal', (options = {}) => {
    nuxtApp.$bus.emit('show-universal-modal', options);
  });

  nuxtApp.provide('closeSimpleModal', () => {
    nuxtApp.$bus.emit('close-universal-modal');
  });
});
